import { colors } from 'Constants/Colors';

const dialogTitle = {
  display: 'flex',
  fontWeight: 'normal',
  color: colors.BLACK,
  fontFamily: 'quicksand',
  backgroundColor: colors.BLACK,
  height: '2.5em',
  flexDirection: 'row',
  justifyContent: 'flex-end',
};

const iconButton = {
  color: colors.WHITE,
  marginRight: '-10px',
};

const dialogContent = {
  paddingTop: '2em',
};

const acceptButton = {
  marginTop: '2em',
  width: '100%',
  fontFamily: 'quicksand',
  color: colors.WHITE,
  fontWeight: 'bold',
};

export default {
  dialogTitle,
  iconButton,
  dialogContent,
  acceptButton,
};
